<template>
	<div :style="{display:!visible?'none':'auto'}" style="margin-right: 10px;">
		<vxe-button size="mini" content="导出" @click="exportData" v-if="table"></vxe-button>
		<vxe-button size="mini" content="批量修改" @click="clickEvent"></vxe-button>
		<vxe-modal v-model="modelShow" width="400" height="400" title="修改字段" @show="show" @hide="hide" show-close
			:mask="false" :draggable="false" :showFooter="true" transfer>
			<div ref="batchmodify" style="margin-top: 10px;margin-bottom: 10px;"></div>
			<template #footer>
				<vxe-button status="" content="取消" @click="cancle"></vxe-button>
				<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>

</template>
<style>
	.form_loading {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
<style scoped>

</style>
<script>
	const batchmodifyRes = {
		rule: {
			"width": "400",
			"height": "auto",
			"fApi": [],
			// "rule": [{
			// 		"type": "$warehouse",
			// 		"field": "name",
			// 		"title": "职务名称",
			// 		"value": null,
			// 		"props": []
			// 	},
			// 	{
			// 		"type": "$emun",
			// 		"field": "enable",
			// 		"title": "是否启用",
			// 		"value": null,
			// 		"props": {
			// 			"name": "enable",
			// 			"initValue": null
			// 		}
			// 	}
			// ],
			"option": {
				"form": {
					"labelWidth": "100px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	export default {
		props: {
			fields: {
				type: Array,
				default: () => {
					return []
				}
			},
			buttons: {
				type: Array,
				default: () => {
					return []
				}
			},
			table: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				fApi: null,
				modelShow: false,
				rule: {},
				visible: true,
			}
		},
		created() {

		},
		mounted() {
			this.visible = this.buttons.length? this.buttons[0].visible:true
			this.init()

		},
		watch: {

		},
		computed: {

		},
		methods: {
			init() {
				let rule = []
				let res = JSON.parse(JSON.stringify(batchmodifyRes))
				let fields = []
				this.rule = res.rule
				this.fields.forEach((item) => {
					// if (!item.hidden && !item.props.disabled && !item.props.readonly && item.type != '$quote') {
					if (!item.hidden && !item.props.disabled && !item.props.readonly) {	
						fields.push({
							label:item.title,
							value:item.field
						})
						rule.push({
							type: item.type,
							field: item.field,
							title: item.title,
							value: null,
							hidden:true,
							options:item.options?item.options:[],
							props: item.props
						})
					}
				})
				rule.unshift({
					type: '$select',
					field: 'batch_update_fields',
					title: '修改字段',
					value: null,
					options:fields,
					props:{
						multiple:false
					},
					on:{
						input:()=>{
							this.batchUpdateFields()
						}
					}
				})
				this.rule.rule = rule				
				this.modalShow = true
			},
			batchUpdateFields(){
				let batch_update_fields = this.getBatchUpdateFields()
				let fields = this.fApi.fields()
				fields.forEach((item)=>{
					if(item!='batch_update_fields'){
						this.fApi.updateRule(item,{hidden:true})
					}else{
						this.fApi.updateRule(item,{hidden:false})
					}
				})
				let activefields = fields.filter((item) => {
					return batch_update_fields.includes(item)
				})
				activefields.forEach((item)=>{
					this.fApi.updateRule(item,{hidden:false})
				})
			},
			show() {
				let rule = this.rule.rule
				let option = this.rule.option
				option.el = this.$refs.batchmodify
				if (!this.fApi) {
					this.fApi = this.$formCreate(rule, option)
				}

			},
			hide() {
				let fields = this.fApi.fields()
				fields.forEach((item)=>{
					if(item!='batch_update_fields'){
						this.fApi.updateRule(item,{hidden:true})
					}else{
						this.fApi.updateRule(item,{hidden:false})
					}
				})
			},
			clickEvent() {
				if (this.rule.rule.length == 0) {
					this.$message.error('暂无可修改项')
				} else {
					this.modelShow = true
				}

			},
			cancle() {
				this.modelShow = false
			},
			exportData(){
				this.table.exportData()
			},
			getBatchUpdateFields(){
				let batch_update_fields = this.fApi.getValue('batch_update_fields')
				if(!Array.isArray(batch_update_fields)){
					batch_update_fields = [batch_update_fields]
				}
				return batch_update_fields
			},
			submit() {
				let data = this.fApi.formData(this.getBatchUpdateFields())
				
				// console.log(data)
				let fullData = this.table.getTableData().fullData
				for (let i in data) {
					if (data[i] != null) {
						fullData.forEach((item) => {
							item[i] = data[i]
						})
					}
				}
				this.$emit('submit', {
					code: 'batchmodify',
					data: data,
					table: this.table
				})
				this.fApi.resetFields()
				this.modelShow = false
			}
		},
		components: {

		}
	}
</script>
